import React from 'react';
import Image from '../../../../../../app/js/components/loggedout/common/Image';

import ImacIpad from "~images/sem/imac-ipad2.png";

const ImacSection = () => {
  return (
    <Image src={ImacIpad} />
  )
}
export default ImacSection